import React from "react";

function BlogSkeleton() {
  return (
    <div className="bg-slate-100 h-full">
      <div className="container mx-auto py-12 px-2 md:px-0 animate-pulse">
        <div className="text-center">
          <div className="h-4 bg-slate-200 rounded w-32 mx-auto mb-2" />
          <div className="h-8 bg-slate-200 rounded w-2/3 mx-auto" />
        </div>

        <div className="mb-10 mx-5 flex justify-center mt-10">
          <div className="h-12 bg-slate-200 rounded w-full max-w-md" />
        </div>

        <div className="flex justify-center gap-2 mb-5">
          {Array.from({ length: 3 }).map((_, idx) => (
            <div key={idx} className="h-8 bg-slate-200 rounded w-20" />
          ))}
        </div>

        <div className="grid gap-5 md:grid-cols-3 mx-5">
          {Array.from({ length: 6 }).map((_, idx) => (
            <div
              key={idx}
              className="bg-white rounded overflow-hidden border border-slate-200"
            >
              <div className="w-full h-48 bg-slate-200" />
              <div className="px-10 py-5 space-y-3">
                <div className="h-3 bg-slate-200 rounded w-1/2" />
                <div className="h-5 bg-slate-200 rounded w-3/4" />
                <div className="h-4 bg-slate-200 rounded w-full" />
                <div className="h-4 bg-slate-200 rounded w-5/6" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BlogSkeleton;